<template>
  <div class="bg-primary">
    <!-- Header -->
    <div class="header bg-gradient-blue py-7 py-lg-6 pt-lg-5">
      <b-container>
        <div class="header-body text-center mb-5">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Create an account</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-primary" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--7 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <validation-observer
              v-slot="{ handleSubmit, passed }"
              ref="formValidator"
            >
              <b-form role="form" @submit.prevent="handleSubmit(createAccount)">
                <b-card-body>
                  <base-input
                    alternative
                    class="mb-3"
                    name="Name"
                    :rules="{ required: true }"
                    :debounce="500"
                    type="text"
                    placeholder="Account name"
                    v-model="model.name"
                  ></base-input>

                  <base-alert
                    v-if="errorMessage"
                    :dismissible="false"
                    type="default"
                    icon="fas fa-exclamation-circle"
                    >Error: {{ errorMessage }}</base-alert
                  >
                </b-card-body>
                <b-card-footer>
                  <b-row>
                    <b-col cols="6" class="text-left">
                      <b-btn to="/select-account" variant="link">Cancel</b-btn>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <base-button
                        native-type="submit"
                        type="success"
                        :disabled="!passed"
                      >
                        <span v-if="!creating"
                          >Create <i class="fa fa-arrow-right ml-2"></i
                        ></span>
                        <span v-else
                          ><i class="fa fa-spin fa-spinner mr-2"></i> Please
                          wait&hellip;</span
                        >
                      </base-button>
                    </b-col>
                  </b-row>
                </b-card-footer>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { BaseAlert } from "@/components";
import { get } from "dot-prop";

export default {
  components: {
    BaseAlert
  },
  data() {
    return {
      model: {
        name: ""
      },
      creating: false,
      errorMessage: null
    };
  },
  methods: {
    createAccount: function() {
      this.creating = true;

      // create account
      const requestBody = { name: this.model.name };
      this.axios
        .post(`/v1/accounts`, requestBody)
        .then(response => {
          // set to local storage
          const account = response.data;
          this.$store.commit("SET_ACCOUNT", account);

          return this.axios.get(`/v1/accounts/${account.id}/members/current`);
        })
        .then(response => {
          this.creating = false;
          this.$store.commit("SET_MEMBERSHIP", response.data);

          // go to account dashboard
          this.$router.push("/dashboard");
        })
        .catch(error => {
          this.creating = false;
          this.errorMessage = "Failed to create account";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    }
  }
};
</script>
